const RAILWAY_CONST = {
  API_ENDPOINT: {
    LOGIN: "/users/login",
    CHART_SPEED_TIME: "/chart_speed_time",
    SPEED_BEFORE_HALT: "/speed_before_halt",
    SPEED_AFTER_HALT: "/speed_after_halt",
    STAT: "/stat",
    CREW_ID: "/crew_id/",
    CREW: "/crew",
    STAT_SPEED_BEFORE_HALT: "/stat_speed_before_halt",
    STAT_SPEED_AFTER_HALT: "/stat_speed_after_halt",
    REPORTS: "reports",
    REPORTS_SLASH: "reports/",
    TEMPLATE: "metadata/templates",
    GET_STATION: "get_station",
    NEW_REPORT: "new_report",
    UPDATE_REPORT: "update_report",
    SUPPORTED_DATA_SOURCES: "supported_data_sources",
    METADATA: "/metadata",
    MANAGEMENT_SUMMARY: "/management/reports/summary",
    MANAGEMENT_lP_SUMMARY: "/management/reports/lp_summary",
    MANAGEMENT_DAILY_SUMMARY: "/management/reports/dalily",
    BULK_DOWNLOAD: "bulk_download",
    CONTACT_US: "/contact_us",
    BREAKING_PATTERN: "/reports/ext_data",
    CHANGEPASSWORD: "/users/password",
    FORGETPASSWORD: "/users/forget_password",
    RESET_PASSWORD: "/users/reset_password",
    GPS_TEMPLATES: "/gps/templates",
    GPS: "/gps",
    REPLACE: "/replace",
    UNPAIRE_LIST: "/metadata/templates",
    HALT_REPORT: "/halt_report/unique_halt/",
    HALT_DATA: "/halt_report/halt_data",
    HALT_FIG: "/halt_report/halt_fig",
  },

  ROUTE: {
    ROOT: "/",
    HOME: "/home",
    LOGIN: "/login",
    REPORT_GENERATE: "/reportGenerate",
    DASHBOARD: "/dashboard",
    TEMPLATE: "/templates",
    REPORTS: "/reports",
    CREATE_REPORT: "/createReport",
    CREATE_TEMPLATE: "/createTemplate",
    UPDATE_TEMPLATE: "/updateTemplate",
    CONTROL_CENTER: "/controlCenter",
    PROFILE: "/profile",
    FORGETPASSWORD: "/forgetPassword",
    ROUTELIST: "/routeList",
    TEMPLATE_DETAIL: "/templateDetails",
    NOT_FOUND: "*",
  },
};

export default RAILWAY_CONST;
